import { gql } from "@apollo/client";
import moment from "moment";

const GET_DOCUMENTOS_VISITAS = gql`
    query documentosVisitasAsistencial($idEvaluacion: Int!) {
        documentosVisitasAsistencial(idEvaluacion: $idEvaluacion) {
            success,
            error,
            valorEsperado {
                idArchivo,
                idTipoArchivoDocumento,
                tipoArchivo,
                titulo,
                datos,
                fechaAlta,
                tipoProfesional,
                profesional,
                referencia,
                nroTalonario
            }
        }
    }
`;

export default GET_DOCUMENTOS_VISITAS;

export const adaptDocumento = (documento) => {
  return {
    idArchivo: documento?.idArchivo,
    idTipoArchivoDocumento: documento?.idTipoArchivoDocumento,
    tipoArchivo: documento?.tipoArchivo,
    titulo: documento?.titulo,
    datos: documento?.datos,
    tipoProfesional: documento?.tipoProfesional,
    profesional: documento?.profesional,
    referencia: documento?.referencia,
    nroTalonario: documento?.nroTalonario,
    fechaAlta: moment(documento?.fechaAlta).format('DD/MM/yyyy')
  };
};

export const adaptDocumentosArray = (documentos) => {
  return structuredClone(documentos?.documentosVisitasAsistencial?.valorEsperado)?.
  map((documento) => adaptDocumento(documento));
};